"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../api");
var codec_1 = require("../../codec");
function balancesAddressGet(sdk, address) {
    return sdk.wrapResponseWithHeight(new api_1.BankApi(undefined, sdk.url).bankBalancesAddressGet(address.toBech32()));
}
exports.balancesAddressGet = balancesAddressGet;
function accountsAddressTransfersPost(sdk, address, req) {
    return new api_1.BankApi(undefined, sdk.url)
        .bankAccountsAddressTransfersPost(address.toBech32(), req)
        .then(function (res) {
        res.data = codec_1.codec.fromJSONString(JSON.stringify(res.data));
        return res;
    });
}
exports.accountsAddressTransfersPost = accountsAddressTransfersPost;
